"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCamelcase = void 0;
const camelcase_keys_1 = __importDefault(require("camelcase-keys"));
const toCamelcase = (object) => {
    try {
        return JSON.parse(JSON.stringify((0, camelcase_keys_1.default)(object, {
            deep: true,
        })));
    }
    catch (error) {
        console.error(error);
    }
    return null;
};
exports.toCamelcase = toCamelcase;
